"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAnalyticsEventDto = instanceOfAnalyticsEventDto;
exports.AnalyticsEventDtoFromJSON = AnalyticsEventDtoFromJSON;
exports.AnalyticsEventDtoFromJSONTyped = AnalyticsEventDtoFromJSONTyped;
exports.AnalyticsEventDtoToJSON = AnalyticsEventDtoToJSON;
exports.AnalyticsEventDtoToJSONTyped = AnalyticsEventDtoToJSONTyped;
const EntityViewType_1 = require("./EntityViewType");
const EntityViewPropertiesDto_1 = require("./EntityViewPropertiesDto");
/**
 * Check if a given object implements the AnalyticsEventDto interface.
 */
function instanceOfAnalyticsEventDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('properties' in value) || value['properties'] === undefined)
        return false;
    return true;
}
function AnalyticsEventDtoFromJSON(json) {
    return AnalyticsEventDtoFromJSONTyped(json, false);
}
function AnalyticsEventDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': (0, EntityViewType_1.EntityViewTypeFromJSON)(json['type']),
        'properties': (0, EntityViewPropertiesDto_1.EntityViewPropertiesDtoFromJSON)(json['properties']),
    };
}
function AnalyticsEventDtoToJSON(json) {
    return AnalyticsEventDtoToJSONTyped(json, false);
}
function AnalyticsEventDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': (0, EntityViewType_1.EntityViewTypeToJSON)(value['type']),
        'properties': (0, EntityViewPropertiesDto_1.EntityViewPropertiesDtoToJSON)(value['properties']),
    };
}
//# sourceMappingURL=AnalyticsEventDto.js.map